// built in
import React, {useState} from 'react';
//external
import {Button, Dropdown, Menu} from 'antd';
import {Icon} from '@ant-design/compatible';
//internal
import ExportModal from './ExportModal'
import UploadModal from './UploadModal'

/**
 * export and upload data options in the filter component
 * @returns {JSX.Element}
 * @constructor
 */
const DashboardOptions = () => {

    const [showUploadModal, setShowUploadModal] = useState(false)
    const [showExportModal, setShowExportModal] = useState(false)


    const menu = (
        <Menu>
            <Menu.Item
                key="upload"
                onClick={() => {
                    setShowUploadModal(true)
                }}
            >
                <Icon type='plus'/>
                Upload new data

            </Menu.Item>
            <Menu.Item
                key="download-all"
                onClick={() => {
                    setShowExportModal(true)
                }}
            >
                <Icon type='export'/>Export dashboard
            </Menu.Item>

        </Menu>
    )


    return <>
        <Dropdown
            overlay={menu}
            placement="bottomLeft"
            trigger={['click']}
        >
            <Button shape="circle" icon={<Icon type="menu"/>}/>
        </Dropdown>
        <ExportModal
            showModal={showExportModal}
            setShowModal={setShowExportModal}
        />
        <UploadModal
            showModal={showUploadModal}
            setShowModal={setShowUploadModal}
        />
    </>
}

export default DashboardOptions